import { useState } from 'react';

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle() {
    setIsShowing(!isShowing);
  }

  function toggleValue(val) {
    setIsShowing(val);
  }

  return {
    isShowing,
    toggle,
    toggleValue
  };
};

export { useModal };
